'use strict';

angular.module('amexReconciliationApp')
  .directive('markReviewedButton', function () {
    return {
      templateUrl: 'scripts/views/directives/mark-reviewed-button.html',
      controllerAs: 'MarkReviewedButtonController',
      controller: function (TransactionReviewingService,
                            SelectedTransactionService,
                            LockStatusService,
                            ActiveTransactionModel,
                            TransactionSearchModel,
                            AnalyticsService,
                            AdobeAnalyticsService,
                            SiteConfigModel) {
        var self = this;

        self.isDisabled = function () {
          if (ActiveTransactionModel.hasActiveTransaction()) {
            return LockStatusService.isLocked(ActiveTransactionModel.activeTransaction()) ||
                ActiveTransactionModel.isTransactionReallocated();
          } else {
            return SelectedTransactionService.selectedTransactionsCount() < 1 ||
              SelectedTransactionService.anyFullyLockedSelected() ||
                SelectedTransactionService.anyReallocatedTransaction();
          }
        };

        self.allTransactionsReviewed = function () {
          if (self.isDisabled()) {
            return false;
          }
          return _.every(transactions(), function (transaction) {
            return transaction.mutableTransactionProperties.transactionStatus === 'REVIEWED';
          });
        };
        self.onClick = function () {
          AnalyticsService.trackMarkAsReviewed();
          if (self.allTransactionsReviewed()) {
            TransactionReviewingService.markTransactionsAsUnreviewed(transactions());
            AdobeAnalyticsService.eventTrack('click',{'eventAsset':'Transaction Mark As Unreviewed',tab:'transactionTab'});
          } else {
            TransactionReviewingService.markTransactionsAsReviewed(transactions());
            AdobeAnalyticsService.eventTrack('click',{'eventAsset':'Transaction Mark As Reviewed',tab:'transactionTab'});
          }
        };

        self.buttonText = function () {
          if (self.allTransactionsReviewed()) {
            return 'transactions.MarkUnreviewed';
          }
          return 'transactions.MarkReviewed';
        };

        self.showButton = function showButton() {
          return !SiteConfigModel.approvalSettingOnForRole();
        };

        function transactions() {
          if (ActiveTransactionModel.hasActiveTransaction()) {
            return [ ActiveTransactionModel.activeTransaction() ];
          } else {
            return SelectedTransactionService.selectedTransactions();
          }
        }
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/markReviewedButton.js
// module id = 525
// module chunks = 0